import {
  BillingInterval,
  GetViewerAvailableProgramPlansQuery,
} from '@sandtech-hub-monorepo/ehub-client';
import { AnalyticsPlan } from '@sandtech-hub-monorepo/ui-auth-kit';

import { toMajorAmount } from '../pages/Plans/components/planPricing';

type BillingPlan = NonNullable<
  GetViewerAvailableProgramPlansQuery['viewer']['availablePrograms']
>[number]['billingPlans'][number];

export const FREE_ANALYTICS_PLAN: AnalyticsPlan = {
  id: 'free',
  name: 'Free',
  value: 0,
};

/** A billing plan at the interval the learner picked, for analytics events. */
export const toAnalyticsPlan = (
  plan: BillingPlan,
  interval: BillingInterval
): AnalyticsPlan => {
  const price = plan.prices.find((p) => p.interval === interval);
  return {
    id: plan.id,
    name: plan.name,
    interval,
    value:
      price?.unitAmount != null
        ? toMajorAmount(price.unitAmount, price.currency)
        : 0,
    currency: price?.currency,
  };
};
